import { render, staticRenderFns } from "./AddressDetails.vue?vue&type=template&id=1cacc03c&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"
import style0 from "./AddressDetails.vue?vue&type=style&index=0&id=1cacc03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cacc03c",
  null
  
)

export default component.exports